import React from 'react';
import { Sidebar } from 'react-admin';

const MySideBar = props => (
    <Sidebar {...props} closedSize={64}/>
);

export default MySideBar;